import React, { memo, useCallback, useEffect, useState } from "react";
import { FaBullhorn, FaMicrophone } from "react-icons/fa";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { isEmpty } from "lodash";
const CurrentNew = () => {
  const setAnnouncement = useContextSelector(AuthContext, (ctx) => {
    return ctx.setAnnouncement;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const [messagelist, setMessageList] = useState([]);
  const fetchMessages = useCallback(async () => {
    const { data: response_users } = await apiGet(apiPath.messageList);

    if (response_users.success) {
      setMessageList(response_users?.results);
    }
  }, []);
  useEffect(() => {
    if (!isEmpty(user)) {
      fetchMessages();
    }
  }, [user, fetchMessages]);
  const openAnnouncement = useCallback(() => {
    setAnnouncement(true);
  }, [setAnnouncement]);
  return (
    <div
      onClick={openAnnouncement}
      className="marquee-wrapper marquee-clickable"
    >
      <div
        style={{ display: "flex", alignItems: "center" }}
        className="announcement-row"
      >
        <FaMicrophone color="white" size={17} style={{ marginRight: "5px" }} />
        <marquee class="marquee ng-star-inserted">
          <ul
            style={{
              display: "flex",
              width: "fit-content",
              transform: "translate(-205px)",
            }}
          >
            {messagelist?.length > 0 ? (
              messagelist?.map((res) => {
                return (
                  <li className="ng-star-inserted">
                    <span>
                      <p>{res?.message}</p>
                    </span>
                  </li>
                );
              })
            ) : (
              <li className="ng-star-inserted">
                <span>
                  <p>Welcome to bajifair.live</p>
                </span>
              </li>
            )}
          </ul>
        </marquee>
      </div>
    </div>
  );
};

export default memo(CurrentNew);
